import URL from 'constants/url'
import React, { forwardRef } from 'react'
import { Link } from 'react-router-dom'

const ProductMenuNew = forwardRef((props, ref) => {

  return (
    <>
      <div className='menu_con_new' ref={ref}>
        <div className='menu_div_new' >
          <div className='menu_content renew'>
            <div className='img_wrap'>
            <img src='images/sign-2074973_640.jpg' className='menu_img' />
            </div>
            <div className='menu_subcon renew'>
              <h4>교통약자이동지원</h4>
              <span>
                ▪ 교통약자의 이동권 보장 효과 증진 <br />
                ▪ 교통약자 사회참여여건 확대 <br />
                ▪ 시스템을 통한 통합 관리
              </span>
            </div>
          </div>

          <div className='menu_content renew'>
          <div className='img_wrap'>
            {/* <img src='images/cloud-8533106_640.jpg' className='menu_img' /> */}
            <img src='images/cloud-3406627_640.jpg' className='menu_img' />
          </div>
            <div className='menu_subcon renew'>
              <h4>클라우드 기반 배차시스템</h4>
              <span>
                클라우드 기반 플랫폼 환경에서 안정적인 서비스 및 보안 관리로 운영에 따른 장애를 최소화
              </span>
            </div>
          </div>

          <div className='menu_content renew'>
          <div className='img_wrap'>
            {/* <img src='images/954577_20170519140916_054_0001.jpg' className='menu_img' /> */}
            <img src='images/WiseNavi01.png' className='menu_img' />
            </div>
            <div className='menu_subcon renew'>
              <h4>GIS & SGMobile</h4>
              <span>
                실시간 교통정보 반영을 기본으로 고객의 비즈니스에 맞게 맞춤형으로 제공되는 Smart한 기업형 모바일 네비게이션
              </span>
            </div>
          </div>
        </div>


        <div className='work_process_new'>
        <div className='text_center'>
          <div className='img_con'>
            <img src='images/1-3-01.png' className='icon_img' />
          </div>
          <h5 className='img_h5'>교통약자이동지원</h5>
        </div>
        <div className='text_center'>
          <div className='img_con'>
            <img src='images/1-3-02.png' className='icon_img' />
          </div>
          <h5 className='img_h5'>스마트 택시</h5>
        </div>
        <div className='text_center'>
          <div className='img_con'>
            <img src='images/1-3-03.png' className='icon_img' />
          </div>
          <h5 className='img_h5'>GIS 솔루션</h5>
        </div>
        <div className='text_center'>
          <div className='img_con'>
            <img src='images/1-3-04.png' className='icon_img' />
          </div>
          <h5 className='img_h5'>SmartInfo</h5>
        </div>
      </div>
      <div className='button_wrap_new'>
        <Link to={URL.PRODUCTS} className='detail_btn'>제품 상세보기</Link>
      </div>
      </ div>
      
    </>
  )
})

export default ProductMenuNew
